// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hr-line {
  background-color: #220B3E;
  opacity: 1;
  display: none;
}

.game-background.plinko-game-wrapper {
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: grid;
  /* Press/click effect */
  /* Ripple effect */
  /* Keep disabled state visually distinct */
}
@media only screen and (max-width: 991.98px) {
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .btn-mobile-game-settings {
    border-color: var(--plinkoSettingBtnBorder) !important;
  }
}
.game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-pixi-col #pixi-plinko-game {
  max-height: 553px;
}
.game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-pixi-col #pixi-plinko-game canvas {
  width: 100% !important;
  transform: scale(1.1);
  touch-action: auto !important;
}
@media only screen and (min-width: 992px) {
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-pixi-col #pixi-plinko-game canvas {
    transform: translate(-32px, -52px) scale(1.3);
  }
}
.game-background.plinko-game-wrapper .main-plinko-pixi-container .sky-moon-bg-section {
  text-align: center;
  min-height: 650px;
}
@media only screen and (min-width: 768px) {
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .sky-moon-bg-section {
    min-height: 100%;
    top: -75px;
  }
}
.game-background.plinko-game-wrapper .main-plinko-pixi-container .sky-moon-bg-section > svg {
  min-height: 100%;
  min-width: 100%;
}
.game-background.plinko-game-wrapper .main-plinko-pixi-container #pixi-plinko-bgApp canvas {
  width: 100% !important;
}
.game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container {
  padding-top: 20px;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .pyramid-plinko-row {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1200px) {
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .container,
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .container-lg,
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .container-md,
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .container-sm,
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .container-xl {
    max-width: 1320px;
  }
}
@media screen and (max-width: 767.98px) {
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container {
    padding-top: 37px;
  }
}
.game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .plinko-game-sidebar-col {
  background-color: var(--PlinkoSidebarBg);
  color: rgba(225, 225, 225, 0.4);
  border-radius: 20px;
  margin: 0 auto;
  z-index: 10;
}
@media only screen and (min-width: 992px) {
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .plinko-game-sidebar-col {
    min-height: 593px;
    max-width: 358px;
  }
}
@media screen and (max-height: 548.98px) {
  .game-background.plinko-game-wrapper .main-plinko-pixi-container .plinko-overlay-container .plinko-game-sidebar-col {
    max-height: 400px;
    overflow-y: auto;
    min-height: inherit;
  }
}
.game-background.plinko-game-wrapper .mobileGameSettingHeaderSection {
  color: var(--white);
}
.game-background.plinko-game-wrapper .mobileGameSettingHeaderSection .btn-close-mobile-game-setting {
  color: rgba(225, 225, 225, 0.4);
  border: 0;
}
.game-background.plinko-game-wrapper .mobileGameSettingHeaderSection .btn-close-mobile-game-setting .btn-close-modal {
  border-color: transparent;
}
.game-background.plinko-game-wrapper .tabSection .row {
  --bs-gutter-x: 0.625rem;
}
.game-background.plinko-game-wrapper .tabSection .row .btn-plinko-mode {
  padding: 0.25rem;
  border-radius: 0.5rem;
  font-size: 0.925rem;
  min-height: 40px;
  background: #252933 !important;
  color: rgba(225, 225, 225, 0.4);
  border: none;
}
.game-background.plinko-game-wrapper .tabSection .row .btn-plinko-mode.active {
  border-radius: 8px;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%) !important;
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  color: var(--white);
}
.game-background.plinko-game-wrapper .lineSection .lines-row {
  gap: 0.313rem;
}
.game-background.plinko-game-wrapper .lineSection .lines-row .line-btn {
  text-align: center;
  border: 2px solid transparent;
  font-size: 0.925rem;
  width: 30px;
  height: 30px;
  background: var(--plinkoBtnPrimary);
  color: rgba(225, 225, 225, 0.4);
  border: none;
}
.game-background.plinko-game-wrapper .lineSection .lines-row .line-btn.active:enabled {
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%) !important;
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  background-origin: border-box;
  color: var(--white);
}
.game-background.plinko-game-wrapper .lineSection .lines-row .line-btn.active:disabled {
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%) !important;
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  background-origin: border-box;
  color: var(--white);
}
.game-background.plinko-game-wrapper .gameSpeedSection .btn-plinko-primary {
  min-width: 80px;
  background: #252933 !important;
  color: rgba(255, 255, 255, 0.4);
  border: 0;
}
.game-background.plinko-game-wrapper .gameSpeedSection .btn-plinko-primary.active {
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%) !important;
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  border: 0;
  color: var(--white);
}
.game-background.plinko-game-wrapper .gameSpeedSection .gap-10 {
  gap: 10px;
}
.game-background.plinko-game-wrapper .autoBetSection .bet-amount-input {
  background-color: #252933;
  border-radius: 0.625rem;
  padding: 0.313rem 0.313rem;
}
.game-background.plinko-game-wrapper .autoBetSection .bet-amount-input .input-group-text,
.game-background.plinko-game-wrapper .autoBetSection .bet-amount-input .form-control {
  background-color: transparent;
  border: 0;
  padding: 0 0.5rem;
  color: var(--white);
}
.game-background.plinko-game-wrapper .autoBetSection .bet-amount-input .input-group-text:focus,
.game-background.plinko-game-wrapper .autoBetSection .bet-amount-input .form-control:focus {
  box-shadow: none;
}
.game-background.plinko-game-wrapper .autoBetSection .bet-amount-input .input-group-text button {
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%) !important;
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  border-radius: 0.313rem;
  border: 0;
  padding: 0.422rem 0.8rem;
}
@media screen and (max-width: 767px) {
  .game-background.plinko-game-wrapper .autoBetSection .bet-amount-input .input-group-text button {
    padding: 0.3rem 0.55rem;
  }
}
.game-background.plinko-game-wrapper .autoBetSection .bet-amount-input .input-group-text button:hover {
  border-color: var(--secondary);
}
.game-background.plinko-game-wrapper .autoBetSection .mul-button button {
  background: #252933 !important;
  border: 0;
  border-radius: 10px;
  min-height: 39px;
}
@media only screen and (max-width: 991.98px) {
  .game-background.plinko-game-wrapper .game-setting-mobile-view {
    position: fixed;
    top: -100%;
    left: 0;
    right: 0;
    z-index: 1004;
    background-color: var(--PlinkoSidebarBg);
    border-radius: 0 0 1.25rem 1.25rem;
    transition: top 600ms;
  }
  .game-background.plinko-game-wrapper .game-setting-mobile-view.setting-open {
    top: 0;
  }
  .game-background.plinko-game-wrapper .game-setting-mobile-overlay {
    position: fixed;
    inset: 0;
    z-index: 1003;
    background-color: var(--black-25);
  }
}
@media only screen and (max-width: 991.98px) {
  .game-background.plinko-game-wrapper .plinko-bet-history-col {
    position: absolute;
    top: 110px;
    right: 6px;
  }
}
@media only screen and (max-width: 767.98px) {
  .game-background.plinko-game-wrapper .plinko-bet-history-col {
    position: absolute;
    top: 75px;
    right: 6px;
  }
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history {
  z-index: 2;
  min-width: 50px;
  max-height: 480px;
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .red {
  background-color: #C82020 !important;
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .orange {
  background-color: #FC6F1F !important;
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .pink {
  background-color: #B122F4 !important;
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .purple {
  background-color: #8951FF !important;
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .blue {
  background-color: #346DFF !important;
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .green {
  background-color: #3CBCB4 !important;
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .plinko-bet-history-item {
  min-width: 42px;
  min-height: 42px;
  background-color: var(--plinkoBlue700);
  color: var(--white);
  border-radius: 0.5rem;
  padding: 0.25rem;
}
@media only screen and (min-width: 992px) {
  .game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .plinko-bet-history-item {
    border-radius: 0.625rem;
  }
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .plinko-bet-history-item:not(:last-child) {
  margin-bottom: 0.375rem;
}
.game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .plinko-bet-history-item:nth-child(n+11) {
  display: none !important;
}
@media only screen and (max-width: 991.98px) {
  .game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .plinko-bet-history-item {
    min-width: 36px;
    min-height: 36px;
  }
  .game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .plinko-bet-history-item:nth-child(n+7) {
    display: none !important;
  }
}
.game-background.plinko-game-wrapper .form-plinko-select {
  border-color: var(--plinkoSelectBorder);
  background-color: var(--PlinkoSidebarBg);
  min-height: 40px;
  min-width: 80px;
}
.game-background.plinko-game-wrapper .form-plinko-select.expanded {
  border-color: var(--borderPinkColor);
}
.game-background.plinko-game-wrapper .form-plinko-select.select-el span {
  line-height: 2.2rem;
}
.game-background.plinko-game-wrapper .form-plinko-select.select-el::after {
  top: 5px;
}
.game-background.plinko-game-wrapper .btn-plinko-bet {
  font-size: 0.875rem;
  min-height: 50px;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%) !important;
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  color: var(--white);
  border: 0;
  border-radius: 8px;
  transition: transform 0.1s ease, box-shadow 0.1s ease, filter 0.1s ease;
  position: relative;
  overflow: hidden;
}
.game-background.plinko-game-wrapper .btn-plinko-bet:active:not(:disabled) {
  transform: scale(0.95);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  filter: brightness(0.9);
}
.game-background.plinko-game-wrapper .btn-plinko-bet::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: inherit;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.game-background.plinko-game-wrapper .btn-plinko-bet:active:not(:disabled)::after {
  opacity: 1;
}
.game-background.plinko-game-wrapper .btn-plinko-bet:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.game-background.plinko-game-wrapper .btn-plinko-switch {
  background: var(--plinkoBtnPrimary);
  min-height: 40px;
  padding: 8px 14px;
  border-radius: 10px;
  min-width: 130px;
}
.game-background.plinko-game-wrapper .form-control {
  padding: 0.2rem 0.75rem;
  border-color: var(--plinkoBtnPrimary);
  background: var(--primary);
  color: var(--white);
}
.game-background.plinko-game-wrapper label {
  font-weight: 400;
  font-size: 14px;
  color: rgba(225, 225, 225, 0.4);
}
.game-background .live-bets-data-table {
  position: relative;
  z-index: 999;
}
.game-background .live-bets-data-table .custom-select-box {
  min-height: 2.5rem;
}
@media only screen and (max-width: 767.98px) {
  .game-background .live-bets-data-table .column-hide {
    display: none;
  }
}

body:has(.plinko-game-wrapper) {
  background: var(--plinkoSwitchBg);
}

@media only screen and (min-width: 992px) {
  .plinko-overlay-container .container {
    max-width: 1550px !important;
    padding-left: 20px !important;
    margin-left: 20px !important;
  }
  .pyramid-plinko-row {
    justify-content: flex-start !important;
    align-items: center;
    gap: 70px;
  }
  .plinko-game-sidebar-col {
    margin-left: -120px;
    flex: 0 0 358px;
    position: relative;
    z-index: 5;
  }
  .plinko-pixi-col {
    padding-left: 0;
  }
  .plinko-pixi-col #pixi-plinko-game {
    max-height: unset;
  }
  .plinko-pixi-col #pixi-plinko-game canvas {
    width: 100% !important;
    transform: translate(68px, -82px) scale(1.15) !important;
    transform-origin: center center;
  }
  .game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .plinko-bet-history-item {
    min-width: 80px;
    min-height: 60px;
    font-size: 1rem;
  }
  .history-sidebar {
    margin-top: -120px;
  }
}
@keyframes historyItemEnter {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.plinko-bet-history-item {
  animation: historyItemEnter 0.4s ease-out;
}

@media only screen and (max-width: 991.98px) {
  .game-background.plinko-game-wrapper .game-setting-mobile-view:not(.setting-open) {
    visibility: hidden;
    pointer-events: none;
    transform: translateY(-100%);
  }
}
@media only screen and (max-width: 991.98px) and (orientation: portrait) {
  .plinko-pixi-col #pixi-plinko-game canvas {
    transform: scale(1.1) !important;
    transform-origin: center center;
  }
}
@media only screen and (max-width: 991.98px) and (orientation: landscape) {
  html:has(.plinko-game-wrapper),
  body:has(.plinko-game-wrapper) {
    overflow: hidden !important;
    height: 100%;
    overscroll-behavior: none;
  }
  .game-background.plinko-game-wrapper {
    height: 100dvh;
    overflow: hidden;
  }
  .game-background.plinko-game-wrapper .main-plinko-pixi-container {
    height: 100%;
    overflow: hidden;
  }
  .game-background.plinko-game-wrapper .live-bets-data-table {
    display: none;
  }
  .game-background.plinko-game-wrapper .game-setting-mobile-view,
  .game-background.plinko-game-wrapper .game-setting-mobile-overlay {
    display: none !important;
  }
  .game-background.plinko-game-wrapper .plinko-bet-history-col {
    position: absolute;
    top: 80px;
    right: 15px;
  }
  .game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history-item {
    min-width: 40px !important;
    min-height: 30px !important;
    font-size: 0.7rem;
    padding: 0.15rem;
    margin-bottom: 4px;
  }
  .plinko-overlay-container {
    padding-top: 0 !important;
    height: 100%;
  }
  .plinko-overlay-container .container {
    max-width: 100% !important;
    padding: 0 8px !important;
    margin: 0 !important;
    flex: 1 1;
    min-height: 0;
  }
  .pyramid-plinko-row {
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
    align-items: center !important;
    height: 100% !important;
    gap: 8px;
  }
  .plinko-game-sidebar-col {
    order: 0 !important;
    flex: 0 0 358px !important;
    width: 358px !important;
    max-width: 358px !important;
    margin: 0 !important;
    padding: 12px !important;
    max-height: none !important;
    min-height: 0 !important;
    overflow: visible !important;
    align-self: center !important;
    position: static;
    zoom: 0.55;
  }
  .plinko-game-sidebar-col > [class*=order-] {
    order: 0 !important;
  }
  .plinko-game-sidebar-col .gameSpeedSection > label,
  .plinko-game-sidebar-col .autoBetSection > label {
    display: block !important;
  }
}
@media only screen and (max-width: 991.98px) and (orientation: landscape) and (max-height: 360px) {
  .plinko-game-sidebar-col {
    zoom: 0.35;
  }
}
@media only screen and (max-width: 991.98px) and (orientation: landscape) and (min-height: 361px) and (max-height: 420px) {
  .plinko-game-sidebar-col {
    zoom: 0.46;
  }
}
@media only screen and (max-width: 991.98px) and (orientation: landscape) and (min-height: 500px) {
  .plinko-game-sidebar-col {
    zoom: 0.7;
  }
}
@media only screen and (max-width: 991.98px) and (orientation: landscape) and (min-height: 650px) {
  .plinko-game-sidebar-col {
    zoom: 0.9;
  }
}
@media only screen and (max-width: 991.98px) and (orientation: landscape) {
  .plinko-pixi-col {
    order: 1 !important;
    flex: 1 1 !important;
    min-width: 0;
    width: auto !important;
    padding-left: 0;
    align-self: center;
  }
  .plinko-pixi-col #pixi-plinko-game {
    max-height: unset;
    height: calc(100dvh - 70px);
    width: 100%;
  }
  .plinko-pixi-col #pixi-plinko-game canvas {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
    transform: scale(1.4) !important;
    transform-origin: center center;
  }
  .plinko-overlay-container > :last-child {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/games/Plinko/GameTheme/PyramidPlinkoGame/pyramidPlinkoGame.scss"],"names":[],"mappings":"AAMA;EACE,yBAAA;EACA,UAAA;EACA,aAAA;AALF;;AASE;EACE,YAAA;EACA,WAAA;EACA,0BAAA;EACA,4BAAA;EACA,aAAA;EAkXA,uBAAA;EAOA,kBAAA;EAeA,0CAAA;AA3YJ;AAaM;EACE;IACE,sDAAA;EAXR;AACF;AAeQ;EACE,iBAAA;AAbV;AAeU;EACE,sBAAA;EACA,qBAAA;EACA,6BAAA;AAbZ;AAeY;EALF;IAMI,6CAAA;EAZZ;AACF;AAiBM;EACE,kBAAA;EACA,iBAAA;AAfR;AAiBQ;EAJF;IAKI,gBAAA;IACA,UAAA;EAdR;AACF;AAgBQ;EACE,gBAAA;EACA,eAAA;AAdV;AAmBQ;EACE,sBAAA;AAjBV;AAqBM;EACE,iBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAnBR;AAqBQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAnBV;AAsBQ;EAEE;;;;;IAKE,iBAAA;EArBV;AACF;AAwBQ;EA3BF;IA4BI,iBAAA;EArBR;AACF;AAuBQ;EACE,wCAAA;EACA,+BAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AArBV;AAuBU;EAPF;IAQI,iBAAA;IACA,gBAAA;EApBV;AACF;AAsBU;EAZF;IAaI,iBAAA;IACA,gBAAA;IACA,mBAAA;EAnBV;AACF;AA0BI;EACE,mBAAA;AAxBN;AA0BM;EACE,+BAAA;EACA,SAAA;AAxBR;AA0BQ;EACE,yBAAA;AAxBV;AA8BM;EACE,uBAAA;AA5BR;AA8BQ;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,+BAAA;EACA,YAAA;AA5BV;AA8BU;EACE,kBAAA;EAvJV,wEAAA;EACA,kLAAA;EACA,WAAA;EAuJU,mBAAA;AA1BZ;AAiCM;EACE,aAAA;AA/BR;AAiCQ;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,+BAAA;EACA,YAAA;AA/BV;AAiCU;EA7KR,wEAAA;EACA,kLAAA;EACA,WAAA;EA6KU,6BAAA;EACA,mBAAA;AA7BZ;AAgCU;EAnLR,wEAAA;EACA,kLAAA;EACA,WAAA;EAmLU,6BAAA;EACA,mBAAA;AA5BZ;AAmCM;EACE,eAAA;EACA,8BAAA;EACA,+BAAA;EACA,SAAA;AAjCR;AAmCQ;EAnMN,wEAAA;EACA,kLAAA;EACA,WAAA;EAmMQ,SAAA;EACA,mBAAA;AA/BV;AAmCM;EACE,SAAA;AAjCR;AAsCM;EACE,yBAAA;EACA,uBAAA;EACA,0BAAA;AApCR;AAsCQ;;EAEE,6BAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;AApCV;AAsCU;;EACE,gBAAA;AAnCZ;AAwCU;EAlOR,wEAAA;EACA,kLAAA;EACA,WAAA;EAkOU,uBAAA;EACA,SAAA;EACA,wBAAA;AApCZ;AAsCY;EANF;IAOI,uBAAA;EAnCZ;AACF;AAqCY;EACE,8BAAA;AAnCd;AA0CQ;EACE,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAxCV;AA6CI;EACE;IACE,eAAA;IACA,UAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,wCAAA;IACA,kCAAA;IACA,qBAAA;EA3CN;EA6CM;IACE,MAAA;EA3CR;EA+CI;IACE,eAAA;IACA,QAAA;IACA,aAAA;IACA,iCAAA;EA7CN;AACF;AAmDM;EADF;IAEI,kBAAA;IACA,UAAA;IACA,UAAA;EAhDN;AACF;AAkDM;EAPF;IAQI,kBAAA;IACA,SAAA;IACA,UAAA;EA/CN;AACF;AAiDM;EACE,UAAA;EACA,eAAA;EACA,iBAAA;AA/CR;AAiDQ;EACE,oCAAA;AA/CV;AAkDQ;EACE,oCAAA;AAhDV;AAmDQ;EACE,oCAAA;AAjDV;AAoDQ;EACE,oCAAA;AAlDV;AAqDQ;EACE,oCAAA;AAnDV;AAsDQ;EACE,oCAAA;AApDV;AAuDQ;EACE,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AArDV;AAuDU;EARF;IASI,uBAAA;EApDV;AACF;AAsDU;EACE,uBAAA;AApDZ;AAwDU;EACE,wBAAA;AAtDZ;AAyDU;EArBF;IAsBI,eAAA;IACA,gBAAA;EAtDV;EAwDU;IACE,wBAAA;EAtDZ;AACF;AA4DI;EACE,uCAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;AA1DN;AA4DM;EACE,oCAAA;AA1DR;AA8DQ;EACE,mBAAA;AA5DV;AA+DQ;EACE,QAAA;AA7DV;AAkEI;EACE,mBAAA;EACA,gBAAA;EAzXJ,wEAAA;EACA,kLAAA;EACA,WAAA;EAyXI,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uEAAA;EACA,kBAAA;EACA,gBAAA;AA9DN;AAkEI;EACE,sBAAA;EACA,wCAAA;EACA,uBAAA;AAhEN;AAoEI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,sBAAA;EACA,UAAA;EACA,6BAAA;AAlEN;AAqEI;EACE,UAAA;AAnEN;AAuEI;EACE,mBAAA;EACA,YAAA;AArEN;AAwEI;EACE,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAtEN;AAyEI;EACE,uBAAA;EACA,qCAAA;EACA,0BAAA;EACA,mBAAA;AAvEN;AA0EI;EACE,gBAAA;EACA,eAAA;EACA,+BAAA;AAxEN;AA4EE;EACE,kBAAA;EACA,YAAA;AA1EJ;AA4EI;EACE,kBAAA;AA1EN;AA6EI;EACE;IACE,aAAA;EA3EN;AACF;;AAgFA;EACE,iCAAA;AA7EF;;AAgFA;EAEE;IACE,4BAAA;IACA,6BAAA;IACA,4BAAA;EA9EF;EAiFA;IACE,sCAAA;IACA,mBAAA;IACA,SAAA;EA/EF;EAkFA;IACE,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,UAAA;EAhFF;EAmFA;IACE,eAAA;EAjFF;EAoFA;IACE,iBAAA;EAlFF;EAqFA;IACE,sBAAA;IACA,wDAAA;IACA,+BAAA;EAnFF;EAqFA;IACE,eAAA;IACA,gBAAA;IACA,eAAA;EAnFF;EAsFA;IACE,kBAAA;EApFF;AACF;AAuFA;EACE;IACE,UAAA;IACA,2BAAA;EArFF;EAuFA;IACE,UAAA;IACA,wBAAA;EArFF;AACF;AAqGA;EAEE,yCAAA;AApGF;;AAwGA;EAEI;IACE,kBAAA;IACA,oBAAA;IACA,4BAAA;EAtGJ;AACF;AA8NA;EACE;IACE,gCAAA;IACA,+BAAA;EA5NF;AACF;AAgOA;EAEE;;IAEE,2BAAA;IACA,YAAA;IACA,yBAAA;EA/NF;EAkOA;IACE,cAAA;IACA,gBAAA;EAhOF;EAkOE;IAA8B,YAAA;IAAc,gBAAA;EA9N9C;EA+NE;IAAwB,aAAA;EA5N1B;EA8NE;;IAC+B,wBAAA;EA3NjC;EA6NE;IACE,kBAAA;IACA,SAAA;IACA,WAAA;EA3NJ;EA6NI;IACE,0BAAA;IACA,2BAAA;IACA,iBAAA;IACA,gBAAA;IACA,kBAAA;EA3NN;EAgOA;IACE,yBAAA;IACA,YAAA;EA9NF;EAiOA;IACE,0BAAA;IACA,yBAAA;IACA,oBAAA;IACA,SAAA;IACA,aAAA;EA/NF;EAkOA;IACE,4BAAA;IACA,sCAAA;IACA,8BAAA;IACA,uBAAA;IACA,QAAA;EAhOF;EAoOA;IACE,mBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,oBAAA;IACA,wBAAA;IACA,2BAAA;IACA,wBAAA;IACA,4BAAA;IACA,6BAAA;IACA,gBAAA;IACA,UAAA;EAlOF;EAoOE;IAAsB,mBAAA;EAjOxB;EAkOE;;IAC0B,yBAAA;EA/N5B;AACF;AAiOE;EAA6B;IAA2B,UAAA;EA7NxD;AACF;AA6NE;EAAqD;IAA2B,UAAA;EAzNhF;AACF;AAyNE;EAA6B;IAA2B,SAAA;EArNxD;AACF;AAqNE;EAA6B;IAA2B,SAAA;EAjNxD;AACF;AAkIA;EAiFE;IACE,mBAAA;IACA,oBAAA;IACA,YAAA;IACA,sBAAA;IACA,eAAA;IACA,kBAAA;EAhNF;EAkNE;IACE,iBAAA;IACA,2BAAA;IACA,WAAA;EAhNJ;EAkNI;IACE,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gCAAA;IACA,+BAAA;EAhNN;EAoNA;IACE,wBAAA;EAlNF;AACF","sourcesContent":["@mixin buttonBg {\n  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%) !important;\n  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.40), 0px 1px 0px 0px rgba(239, 116, 3, 0.60) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.30) inset, 0px 0px 15px 0px #EF7403 inset;\n  color: #FFF;\n}\n\n.hr-line {\n  background-color: #220B3E;\n  opacity: 1;\n  display: none;\n}\n\n.game-background {\n  &.plinko-game-wrapper {\n    height: 100%;\n    width: 100%;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    display: grid;\n    // margin-top: -50px;\n\n    // @media only screen and (min-width: 992px) {\n    //   margin-top: -92px;\n    // }\n\n    .main-plinko-pixi-container {\n      // top: 47px;\n\n      @media only screen and (max-width: 991.98px) {\n        .btn-mobile-game-settings {\n          border-color: var(--plinkoSettingBtnBorder) !important;\n        }\n      }\n\n      .plinko-pixi-col {\n        #pixi-plinko-game {\n          max-height: 553px;\n\n          canvas {\n            width: 100% !important;\n            transform: scale(1.1);\n            touch-action: auto !important;\n\n            @media only screen and (min-width: 992px) {\n              transform: translate(-32px, -52px) scale(1.30);\n            }\n          }\n        }\n      }\n\n      .sky-moon-bg-section {\n        text-align: center;\n        min-height: 650px;\n\n        @media only screen and (min-width: 768px) {\n          min-height: 100%;\n          top: -75px;\n        }\n\n        &>svg {\n          min-height: 100%;\n          min-width: 100%;\n        }\n      }\n\n      #pixi-plinko-bgApp {\n        canvas {\n          width: 100% !important;\n        }\n      }\n\n      .plinko-overlay-container {\n        padding-top: 20px;\n        top: 0;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n\n        .pyramid-plinko-row {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n\n        @media (min-width: 1200px) {\n\n          .container,\n          .container-lg,\n          .container-md,\n          .container-sm,\n          .container-xl {\n            max-width: 1320px;\n          }\n        }\n\n        @media screen and (max-width: 767.98px) {\n          padding-top: 37px;\n        }\n\n        .plinko-game-sidebar-col {\n          background-color: var(--PlinkoSidebarBg);\n          color: rgba(225, 225, 225, 0.4);\n          border-radius: 20px;\n          margin: 0 auto;\n          z-index: 10;\n\n          @media only screen and (min-width: 992px) {\n            min-height: 593px;\n            max-width: 358px;\n          }\n\n          @media screen and (max-height:548.98px) {\n            max-height: 400px;\n            overflow-y: auto;\n            min-height: inherit;\n          }\n        }\n      }\n    }\n\n    // start game settings common css for mobile desktop\n\n    .mobileGameSettingHeaderSection {\n      color: var(--white);\n\n      .btn-close-mobile-game-setting {\n        color: rgba(225, 225, 225, 0.4);\n        border: 0;\n\n        .btn-close-modal {\n          border-color: transparent;\n        }\n      }\n    }\n\n    .tabSection {\n      .row {\n        --bs-gutter-x: 0.625rem;\n\n        .btn-plinko-mode {\n          padding: 0.25rem;\n          border-radius: 0.5rem;\n          font-size: 0.925rem;\n          min-height: 40px;\n          background: #252933 !important;\n          color: rgba(225, 225, 225, 0.4);\n          border: none;\n\n          &.active {\n            border-radius: 8px;\n            @include buttonBg();\n            color: var(--white)\n          }\n        }\n      }\n    }\n\n    .lineSection {\n      .lines-row {\n        gap: 0.313rem;\n\n        .line-btn {\n          text-align: center;\n          border: 2px solid transparent;\n          font-size: 0.925rem;\n          width: 30px;\n          height: 30px;\n          background: var(--plinkoBtnPrimary);\n          color: rgba(225, 225, 225, 0.4);\n          border: none;\n\n          &.active:enabled {\n            @include buttonBg();\n            background-origin: border-box;\n            color: var(--white);\n          }\n\n          &.active:disabled {\n            @include buttonBg();\n            background-origin: border-box;\n            color: var(--white);\n          }\n        }\n      }\n    }\n\n    .gameSpeedSection {\n      .btn-plinko-primary {\n        min-width: 80px;\n        background: #252933 !important;\n        color: rgba(255, 255, 255, 0.4);\n        border: 0;\n\n        &.active {\n          @include buttonBg ();\n          border: 0;\n          color: var(--white);\n        }\n      }\n\n      .gap-10 {\n        gap: 10px;\n      }\n    }\n\n    .autoBetSection {\n      .bet-amount-input {\n        background-color: #252933;\n        border-radius: 0.625rem;\n        padding: 0.313rem 0.313rem;\n\n        .input-group-text,\n        .form-control {\n          background-color: transparent;\n          border: 0;\n          padding: 0 0.5rem;\n          color: var(--white);\n\n          &:focus {\n            box-shadow: none;\n          }\n        }\n\n        .input-group-text {\n          button {\n            @include buttonBg ();\n            border-radius: 0.313rem;\n            border: 0;\n            padding: 0.422rem 0.8rem;\n\n            @media screen and (max-width: 767px) {\n              padding: 0.3rem 0.55rem;\n            }\n\n            &:hover {\n              border-color: var(--secondary);\n            }\n          }\n        }\n      }\n\n      .mul-button {\n        button {\n          background: #252933 !important;\n          border: 0;\n          border-radius: 10px;\n          min-height: 39px;\n        }\n      }\n    }\n\n    @media only screen and (max-width: 991.98px) {\n      .game-setting-mobile-view {\n        position: fixed;\n        top: -100%;\n        left: 0;\n        right: 0;\n        z-index: 1004;\n        background-color: var(--PlinkoSidebarBg);\n        border-radius: 0 0 1.25rem 1.25rem;\n        transition: top 600ms;\n\n        &.setting-open {\n          top: 0;\n        }\n      }\n\n      .game-setting-mobile-overlay {\n        position: fixed;\n        inset: 0;\n        z-index: 1003;\n        background-color: var(--black-25);\n      }\n    }\n\n    // close game settings common css for mobile desktop\n\n    .plinko-bet-history-col {\n      @media only screen and (max-width: 991.98px) {\n        position: absolute;\n        top: 110px;\n        right: 6px;\n      }\n\n      @media only screen and (max-width: 767.98px) {\n        position: absolute;\n        top: 75px;\n        right: 6px;\n      }\n\n      .plinko-bet-history {\n        z-index: 2;\n        min-width: 50px;\n        max-height: 480px;\n\n        .red {\n          background-color: #C82020 !important;\n        }\n\n        .orange {\n          background-color: #FC6F1F !important;\n        }\n\n        .pink {\n          background-color: #B122F4 !important;\n        }\n\n        .purple {\n          background-color: #8951FF !important;\n        }\n\n        .blue {\n          background-color: #346DFF !important;\n        }\n\n        .green {\n          background-color: #3CBCB4 !important;\n        }\n\n        .plinko-bet-history-item {\n          min-width: 42px;\n          min-height: 42px;\n          background-color: var(--plinkoBlue700);\n          color: var(--white);\n          border-radius: 0.5rem;\n          padding: 0.25rem;\n\n          @media only screen and (min-width: 992px) {\n            border-radius: 0.625rem;\n          }\n\n          &:not(:last-child) {\n            margin-bottom: 0.375rem;\n          }\n\n\n          &:nth-child(n + 11) {\n            display: none !important;\n          }\n\n          @media only screen and (max-width: 991.98px) {\n            min-width: 36px;\n            min-height: 36px;\n\n            &:nth-child(n + 7) {\n              display: none !important;\n            }\n          }\n        }\n      }\n    }\n\n    .form-plinko-select {\n      border-color: var(--plinkoSelectBorder);\n      background-color: var(--PlinkoSidebarBg);\n      min-height: 40px;\n      min-width: 80px;\n\n      &.expanded {\n        border-color: var(--borderPinkColor);\n      }\n\n      &.select-el {\n        span {\n          line-height: 2.2rem;\n        }\n\n        &::after {\n          top: 5px\n        }\n      }\n    }\n\n    .btn-plinko-bet {\n      font-size: 0.875rem;\n      min-height: 50px;\n      @include buttonBg();\n      color: var(--white);\n      border: 0;\n      border-radius: 8px;\n      transition: transform 0.1s ease, box-shadow 0.1s ease, filter 0.1s ease;\n      position: relative;\n      overflow: hidden;\n    }\n\n    /* Press/click effect */\n    .btn-plinko-bet:active:not(:disabled) {\n      transform: scale(0.95);\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      filter: brightness(0.9);\n    }\n\n    /* Ripple effect */\n    .btn-plinko-bet::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background: rgba(255, 255, 255, 0.2);\n      border-radius: inherit;\n      opacity: 0;\n      transition: opacity 0.2s ease;\n    }\n\n    .btn-plinko-bet:active:not(:disabled)::after {\n      opacity: 1;\n    }\n\n    /* Keep disabled state visually distinct */\n    .btn-plinko-bet:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    .btn-plinko-switch {\n      background: var(--plinkoBtnPrimary);\n      min-height: 40px;\n      padding: 8px 14px;\n      border-radius: 10px;\n      min-width: 130px;\n    }\n\n    .form-control {\n      padding: 0.2rem 0.75rem;\n      border-color: var(--plinkoBtnPrimary);\n      background: var(--primary);\n      color: var(--white);\n    }\n\n    label {\n      font-weight: 400;\n      font-size: 14px;\n      color: rgba(225, 225, 225, 0.4);\n    }\n  }\n\n  .live-bets-data-table {\n    position: relative;\n    z-index: 999;\n\n    .custom-select-box {\n      min-height: 2.5rem;\n    }\n\n    @media only screen and (max-width: 767.98px) {\n      .column-hide {\n        display: none;\n      }\n    }\n  }\n}\n\nbody:has(.plinko-game-wrapper) {\n  background: var(--plinkoSwitchBg);\n}\n\n@media only screen and (min-width: 992px) {\n\n  .plinko-overlay-container .container {\n    max-width: 1550px !important;\n    padding-left: 20px !important;\n    margin-left: 20px !important;\n  }\n\n  .pyramid-plinko-row {\n    justify-content: flex-start !important;\n    align-items: center;\n    gap: 70px;\n  }\n\n  .plinko-game-sidebar-col {\n    margin-left: -120px;\n    flex: 0 0 358px;\n    position: relative;\n    z-index: 5;\n  }\n\n  .plinko-pixi-col {\n    padding-left: 0;\n  }\n\n  .plinko-pixi-col #pixi-plinko-game {\n    max-height: unset;\n  }\n\n  .plinko-pixi-col #pixi-plinko-game canvas {\n    width: 100% !important;\n    transform: translate(68px, -82px) scale(1.15) !important;\n    transform-origin: center center;\n  }\n  .game-background.plinko-game-wrapper .plinko-bet-history-col .plinko-bet-history .plinko-bet-history-item {\n    min-width: 80px;\n    min-height: 60px;\n    font-size: 1rem;\n  }\n\n  .history-sidebar{\n    margin-top: -120px;\n  }\n}\n\n@keyframes historyItemEnter {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  // 0% {\n  //   opacity: 0;\n  //   transform: scale(0.7) translateY(-10px);\n  // }\n  // 60% {\n  //   opacity: 1;\n  //   transform: scale(1.08) translateY(0);\n  // }\n  // 100% {\n  //   opacity: 1;\n  //   transform: scale(1) translateY(0);\n  // }\n}\n\n.plinko-bet-history-item {\n  // ...existing styles unchanged...\n  animation: historyItemEnter 0.4s ease-out;\n}\n\n// Hide the slide-down mobile settings panel completely when it isn't open\n@media only screen and (max-width: 991.98px) {\n  .game-background.plinko-game-wrapper {\n    .game-setting-mobile-view:not(.setting-open) {\n      visibility: hidden;\n      pointer-events: none;\n      transform: translateY(-100%);\n    }\n  }\n}\n\n// Phone landscape: behave like desktop (sidebar left, pyramid right)\n// @media only screen and (max-width: 991.98px) and (orientation: landscape) {\n//   // lock page scroll (html + body)\n//   html:has(.plinko-game-wrapper),\n//   body:has(.plinko-game-wrapper) {\n//    // overflow: hidden !important;\n//     height: 100%;\n//     overscroll-behavior: none;       // stops rubber-band / pull-to-refresh\n//   }\n\n//   // make the game fill exactly one screen\n//   .game-background.plinko-game-wrapper {\n//     height: 100vh;\n//     height: 100dvh;                  // accounts for mobile browser bars\n//    // overflow: hidden;\n\n//     .main-plinko-pixi-container {\n//       height: 100%;\n//       //overflow: hidden;\n//     }\n\n//     // remove the extra spacing below the game that creates scroll height\n//     .live-bets-data-table {\n//       display: none;\n//     }\n\n//     .plinko-game-sidebar-col {\n//       align-self: flex-start !important;\n//       position: relative;\n//       top: 50px;                       // about -90px on screen at zoom 0.6; tune this\n//       padding: 12px !important;\n//     }\n//   }\n\n//   .game-background.plinko-game-wrapper {\n//     .game-setting-mobile-view,\n//     .game-setting-mobile-overlay {\n//       display: none !important;\n//     }\n//   }\n\n//   .plinko-overlay-container .container {\n//     max-width: 100% !important;\n//     padding-left: 30px !important;\n//     padding-right: 8px !important;\n//     margin-left: 0 !important;\n//     margin-right: 0 !important;\n//     top: 50px !important;\n//   }\n\n//   .pyramid-plinko-row {\n//     flex-wrap: nowrap !important;\n//     justify-content: flex-start !important;\n//     align-items: center !important;\n//     gap: 12px;\n//   }\n\n//   .plinko-game-sidebar-col {\n//     order: 0 !important;                 // beats order-1\n//     flex: 0 0 358px !important;          // same width as desktop, scaled by zoom\n//     width: 358px !important;\n//     max-width: 358px !important;\n//     margin: 0 !important;\n//     max-height: none !important;         // beats the max-height:400px rule\n//     overflow: visible !important;        // no scrollbar\n//     min-height: 0 !important;\n//     zoom: 0.4;                           // shrink the whole panel to fit\n\n//     // restore the desktop order: Difficulty -> ... -> Place Bet\n//     > [class*='order-'] {\n//       order: 0 !important;\n//     }\n\n//     // labels that are hidden below lg\n//     .gameSpeedSection > label,\n//     .autoBetSection > label {\n//       display: block !important;\n//     }\n//   }\n\n//   .plinko-pixi-col {\n//     order: 1 !important;\n//     flex: 1 1 0 !important;\n//     width: auto !important;\n//     min-width: 0;\n//     padding-left: 0;\n\n//     #pixi-plinko-game {\n//       max-height: unset;\n\n//       canvas {\n//         width: 100% !important;\n//         transform: translateX(-50px) translateY(-60px) scale(0.9) !important;\n//         transform-origin: center center;\n//       }\n//     }\n//   }\n\n//   // phones about 360px tall\n//   @media (max-height: 400px) {\n//     .plinko-game-sidebar-col {\n//       zoom: 0.4;\n//     }\n//   }\n\n//   .game-background.plinko-game-wrapper .plinko-bet-history-col {\n//     position: absolute;\n//     top: 100px;      // vertical position\n//     right: 20px;    // change this\n//   }\n\n//   .plinko-overlay-container > :last-child {\n//     display: none !important;\n//   }\n// }\n\n@media only screen and (max-width: 991.98px) and (orientation: portrait) {\n  .plinko-pixi-col #pixi-plinko-game canvas {\n    transform: scale(1.1) !important;   // change this value\n    transform-origin: center center;\n  }\n}\n\n\n@media only screen and (max-width: 991.98px) and (orientation: landscape) {\n\n  html:has(.plinko-game-wrapper),\n  body:has(.plinko-game-wrapper) {\n    overflow: hidden !important;\n    height: 100%;\n    overscroll-behavior: none;\n  }\n\n  .game-background.plinko-game-wrapper {\n    height: 100dvh;\n    overflow: hidden;\n\n    .main-plinko-pixi-container { height: 100%; overflow: hidden; }\n    .live-bets-data-table { display: none; }\n\n    .game-setting-mobile-view,\n    .game-setting-mobile-overlay { display: none !important; }\n\n    .plinko-bet-history-col {\n      position: absolute;\n      top: 80px;\n      right: 15px;\n\n      .plinko-bet-history-item {\n        min-width: 40px !important;\n        min-height: 30px !important;\n        font-size: 0.7rem;\n        padding: 0.15rem;\n        margin-bottom: 4px;\n      }\n    }\n  }\n\n  .plinko-overlay-container {\n    padding-top: 0 !important;\n    height: 100%;\n  }\n\n  .plinko-overlay-container .container {\n    max-width: 100% !important;\n    padding: 0 8px !important;\n    margin: 0 !important;\n    flex: 1 1 0;\n    min-height: 0;\n  }\n\n  .pyramid-plinko-row {\n    flex-wrap: nowrap !important;\n    justify-content: flex-start !important;\n    align-items: center !important;\n    height: 100% !important;\n    gap: 8px;\n  }\n\n  // Sidebar: desktop layout, scaled to the screen height\n  .plinko-game-sidebar-col {\n    order: 0 !important;\n    flex: 0 0 358px !important;\n    width: 358px !important;\n    max-width: 358px !important;\n    margin: 0 !important;\n    padding: 12px !important;\n    max-height: none !important;\n    min-height: 0 !important;\n    overflow: visible !important;\n    align-self: center !important;\n    position: static;\n    zoom: 0.55;                           // default\n\n    > [class*='order-'] { order: 0 !important; }\n    .gameSpeedSection > label,\n    .autoBetSection > label { display: block !important; }\n  }\n\n  @media (max-height: 360px) { .plinko-game-sidebar-col { zoom: 0.35; } }\n  @media (min-height: 361px) and (max-height: 420px) { .plinko-game-sidebar-col { zoom: 0.46; } }\n  @media (min-height: 500px) { .plinko-game-sidebar-col { zoom: 0.7; } }\n  @media (min-height: 650px) { .plinko-game-sidebar-col { zoom: 0.9; } }\n\n  // Pyramid: fill the remaining space without overflowing\n  .plinko-pixi-col {\n    order: 1 !important;\n    flex: 1 1 0 !important;\n    min-width: 0;\n    width: auto !important;\n    padding-left: 0;\n    align-self: center;\n\n    #pixi-plinko-game {\n      max-height: unset;\n      height: calc(100dvh - 70px);        // 70px ≈ header height; tune\n      width: 100%;\n\n      canvas {\n        width: 100% !important;\n        height: 100% !important;\n        object-fit: contain;\n        transform: scale(1.4) !important;   // nudge bigger if there is spare room\n        transform-origin: center center;\n      }\n    }\n  }\n  .plinko-overlay-container > :last-child {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
